<div class="rating" (click)="onClick()" (mouseleave)="onMouseleave()">
  <ng-content></ng-content>
</div>
